import React, { useState } from "react";
import { Box, Typography, Skeleton } from "@mui/material";

type ImageWithLoaderProps = {
  src: string;
  filename: string;
  onClick?: (src: string) => void;
};

export const ImageWithLoader: React.FC<ImageWithLoaderProps> = ({ src, filename, onClick }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <Box
      sx={{
        my: 1,
        width: 400,
        height: 250,
        overflow: "hidden",
        borderRadius: 2,
        border: "1px solid #ccc",
        cursor: "pointer",
        position: "relative",
      }}
      onClick={() => onClick?.(src)}
    >
      {/* Skeleton loader */}
      {!loaded && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ position: "absolute", top: 0, left: 0 }}
        />
      )}

      {/* Image */}
      <Box
        component="img"
        src={src}
        alt={filename}
        data-view-only
        onLoad={() => setLoaded(true)}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: loaded ? "block" : "none",
        }}
      />

      {/* Caption */}
      <Typography variant="caption" color="text.secondary">
        {/* [{filename}] */}
      </Typography>
    </Box>
  );
};
